const reportPathBase = `/reports/`;
const patientsPath = `${reportPathBase}patients`;
const doctorPatientsPath = `${reportPathBase}doctor/patients`;
const appointmentsPath = `${reportPathBase}appointments`;
const doctorFinancialPath = `${reportPathBase}financial/doctor`;
const doctorFinancialForDoctorPath = `${reportPathBase}financial-report/doctor`;
const hfFinancialPath = `${reportPathBase}financial/hf`;
const visitSummaryNotesPath = `${reportPathBase}visit-summary-notes`;

// TODO: add doctor financial
// TODO: add staff patient list
// TODO: add doctor patient list

export const path = {
  patients: {
    route: patientsPath,
    link: () => patientsPath,
  },
  appointments: {
    route: appointmentsPath,
    link: () => appointmentsPath,
  },
  doctorFinancial: {
    route: doctorFinancialPath,
    link: () => doctorFinancialPath,
  },
  hfFinancial: {
    route: hfFinancialPath,
    link: () => hfFinancialPath,
  },
  visitSummaryNotes: {
    route: visitSummaryNotesPath,
    link: () => visitSummaryNotesPath,
  },
  doctorFinancialForDoctorPath: {
    route: doctorFinancialForDoctorPath,
    link: () => doctorFinancialForDoctorPath,
  },
  doctorPatientsPath: {
    route: doctorPatientsPath,
    link: () => doctorPatientsPath,
  },
};
